import { messageBoxSuccess, messageBoxError } from './message-box';
class NewsletterC2A {
  private newsLetterForms: NodeListOf<HTMLFormElement> | null;

  cache() {
    this.newsLetterForms = document.querySelectorAll('.js-newsletter-form');
  }

  bindings() {
    this.newsLetterForms?.forEach((form) => {
      const newsLetterEmailInput: HTMLInputElement | null = form?.querySelector('.js-newsletter-email');
      const newsLetterEmailInputLabel = form?.querySelector('.js-newsletter-label');
      const newsLetterCheckbox = form?.querySelector('.js-newsletter-checkbox');
      const newsLetterCheckboxInput = newsLetterCheckbox?.querySelector('input[type="checkbox"]') as HTMLInputElement;
      const newsLetterCheckboxClassList = newsLetterCheckbox?.classList;
      const newsLetterEmailInputLabelClassList = newsLetterEmailInputLabel?.classList;
      const newsLetterErrorInvalidMail = form?.querySelector('.js-newsletter-error--invalid-mail');
      const newsLetterSubmitBtn = form?.querySelector('button[type="submit"]') as HTMLButtonElement;

      newsLetterEmailInput?.addEventListener('keyup', () => {
        const isEmailValid = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          newsLetterEmailInput.value
        );

        if (newsLetterEmailInput.value.length) {
          newsLetterEmailInputLabelClassList?.remove('hidden');
        } else {
          newsLetterEmailInputLabelClassList?.add('hidden');
        }

        if (isEmailValid) {
          if (newsLetterCheckboxClassList?.contains('hidden')) {
            newsLetterCheckboxClassList.remove('hidden');
          }
          newsLetterEmailInput.classList.remove('has-error');
          newsLetterErrorInvalidMail?.classList.add('hidden');
          newsLetterSubmitBtn.disabled = false;
        } else {
          newsLetterErrorInvalidMail?.classList.remove('hidden');
          newsLetterEmailInput.classList.add('has-error');
          newsLetterCheckboxClassList?.add('hidden');
          newsLetterSubmitBtn.disabled = true;
        }
      });

      newsLetterCheckboxInput?.addEventListener('change', () => this.handleFormError(form, !newsLetterCheckboxInput.checked));

      form.addEventListener('submit', (e) => {
        e.preventDefault();
        form.reportValidity();
        form.classList.add('loading');
        const formData = new FormData(form);
        if(!newsLetterCheckboxInput.checked) {
          this.handleFormError(form);
        } else if(newsLetterCheckboxInput.checked) {
          this.subscribe(formData, form);
        }
      });
    });
  }
  private handleFormError(form: HTMLFormElement, hasError: boolean = true) {
    const newsLetterCheckbox = form?.querySelector('.js-newsletter-checkbox');
    if(newsLetterCheckbox) {
      if(hasError) {
        newsLetterCheckbox.classList.add('has-error');
        // newsLetterCheckbox.querySelector('.error-message')?.classList.remove('hidden');
      } else {
        newsLetterCheckbox.classList.remove('has-error');
        // newsLetterCheckbox.querySelector('.error-message')?.classList.add('hidden');
      }
      form.classList.remove('loading');
    }
  }

  private async subscribe(formData: FormData, form: HTMLFormElement) {
    const apiBaseUrl = document.body.dataset.apiBaseUrl;
    await fetch(apiBaseUrl + 'api/v1/newsletter/subscribe/', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => this.handleSubscribeResponse(data, form))
    .catch(error => this.handleSubscribeResponse(error, form));
  }

  private handleSubscribeResponse(data: any, form: HTMLFormElement) {
    // console.log('handle response', data);
    form.classList.remove('loading');
    if(!data.success) {
      //TODO show Error message
      messageBoxError({
        contentDe: data.message ?? 'Es ist ein Fehler aufgetreten. Bitte versuche es später nocheinmal.',
        contentEn: data.message ?? 'An error appeared. Please try again later.',
      });

    }else {
      //TODO show Success Message
      messageBoxSuccess({
        contentDe: data.message ?? 'Du hast dich erfolgreich zum Newsletter angemeldet.',
        contentEn: data.message ?? 'You subscribed successfully to our newsletter.',
      });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ lead: null });
      window.dataLayer.push({
        event: 'generate_lead',
        lead: {
          type: 'subscribe_newsletter',
          email: data.validated_data.email,
          new_lead: data.hasOwnProperty('is_first_contact') && data.is_first_contact ? 'Yes' : 'No',
        }
      });
      (form.querySelector('input[type="email"]') as HTMLInputElement).value = '';
      (form.querySelector('input[type="checkbox"]') as HTMLInputElement).checked = false;
      (form.querySelector('.js-newsletter-checkbox') as HTMLElement).classList.add('hidden');
    }
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default NewsletterC2A;
